<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" wid="750px" @callFn="fxFlag = false" :title="`图表统计`">
			<div class="tjBoxs">
				<div class="tjBoxItem">
					<div ref="myChart1" style="width: 350px; height: 300px"></div>
				</div>
				<div class="tjBoxItem">
					<div ref="myChart2" style="width: 350px; height: 300px"></div>
				</div>
			</div>
			<div slot="footer"></div>
		</dialogBox>
		<div class="kbTit">
			<div class="kbTLeft">
				<div class="kbFanh" @click="fhKeben">
					<i class="el-icon-arrow-left"></i>
					返回错题分布
				</div>
				<div class="kbFBtns">
					<div class="kbFBtn" @click="btns('up')" :class="fFlag == 0 ? 'active' : ''">
						上一章
						<i class="el-icon-caret-top"></i>
					</div>
					<div class="kbFBtn" @click="btns('down')" :class="fFlag == examArrData.length - 1 ? 'active' : ''">
						下一章
						<i class="el-icon-caret-bottom"></i>
					</div>
				</div>
			</div>
			<div class="kbTj">作答统计 / {{ eindexData.name }}</div>
		</div>
		<div class="kbCont">
			<el-table ref="multipleTable" :data="tableData" header-row-class-name="btClass" tooltip-effect="dark" style="width: 100%">
				<el-table-column align="center" prop="createNickName" label="姓名"></el-table-column>
				<el-table-column align="center" label="作答时间">
					<template slot-scope="scope">
						<div>
							{{ scope.row.createTime | momentYR('YYYY年MM月DD日') }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="正确数">
					<template slot-scope="scope">
						<div class="dfIcon">
							<img src="@/assets/img/zq.svg" alt="" />
							{{ scope.row.rightNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="错误数">
					<template slot-scope="scope">
						<div class="dfIcon dfIcon1">
							<img src="@/assets/img/cwu.svg" alt="" />
							{{ scope.row.wrongNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="score" label="套题得分"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
export default {
	name: 'cuotiJlu',
	data() {
		return {
			fxFlag: false,
			fullscreenLoading: false,
			tableData: [],
			eindexData: {},
			fFlag: 0
		};
	},
	components: {
		dialogBox
	},
	props: ['examData', 'bjId', 'examArrData', 'userTextbookId'],
	methods: {
		btns(type) {
			console.log(7777);
			if (type == 'up') {
				if (this.fFlag == 0) {
					return;
				}
				this.fFlag--;
				this.eindexData = this.examArrData[this.fFlag];
				this.init();
			} else {
				if (this.fFlag == this.examArrData.length - 1) {
					return;
				}
				this.fFlag++;
				this.eindexData = this.examArrData[this.fFlag];
				this.init();
			}
		},
		init() {
			console.log(this.eindexData.id, this.examArrData, this.userTextbookId, 777);
			this.fullscreenLoading = true;
			this.$http
				.get(`api/app/yydAnswerExam/list`, {
					params: {
						bjId: this.bjId,
						examId: this.eindexData.id,
						textbookDirectoryId: this.userTextbookId,
						type: 5
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.tableData = res.rows || [];
					}
				});
		},
		fhKeben() {
			console.log(222);
			this.$emit('fhBtns', 'cuotiFb', 'keben');
		},
		fxFn() {
			this.fxFlag = true;
		},
		txtFn() {
			this.examArrData.forEach((item, index) => {
				if (item.id == this.eindexData.id) {
					this.fFlag = index;
				}
			});
		}
	},
	mounted() {
		this.eindexData = this.examData;
		this.txtFn();
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.kbBox {
	.kbTit {
		height: 80px;
		border-bottom: 1px solid #eeeff2;
		display: flex;
		align-items: center;
		padding: 0 26px 0 16px;
		justify-content: space-between;
		> div {
			display: flex;
			align-items: center;
			font-size: 14px;
			cursor: pointer;
			color: #000000;
			line-height: 1;
			img {
				width: 22px;
				height: 22px;
				margin-right: 4px;
			}
			i {
				margin-right: 4px;
				font-size: 16px;
			}
		}
		.kbTLeft {
			.kbFBtns {
				margin-left: 45px;
				display: flex;
				font-size: 14px;
				color: #3d3d3d;
				.kbFBtn {
					display: flex;
					align-items: center;
					margin-right: 32px;
					font-size: 14px;
					i {
						margin-left: 4px;
					}
				}
				.active {
					color: #b2b1b1;
					cursor: no-drop;
				}
			}
		}
	}
}
.dfIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #1d7b3a;
	font-size: 14px;
	img {
		margin-right: 4px;
		width: 14px;
		height: 14px;
	}
}
.dfIcon1 {
	color: #fa4a1b;
}
.tjBoxs {
	display: flex;
}
</style>
